"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorManualFieldView = void 0;
exports.viewVectorManualEdit = viewVectorManualEdit;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const field_action_button_1 = require("../../../components/button/field.action.button");
const icons_1 = require("../../../components/icon/icons");
const input_1 = require("../../../components/input/input");
const vector_input_1 = require("../../../components/input/vector.input");
const vector_input_state_1 = require("../../../components/input/vector.input.state");
const notification_service_1 = require("../../../components/notification.toast/notification.service");
const theme_1 = require("../../../components/theme");
const index_1 = require("../../../i18n/index");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const page_state_1 = require("../../../state/page.state");
const field_info_1 = require("../../field.info/field.info");
const point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
const CSS = {
    container: 'c-Vector',
    isLinked: 'c-Vector--linked'
};
(0, theme_1.addStyles)({
    [CSS.isLinked]: {
        display: 'flex',
        'justify-content': 'flex-end'
    }
});
function linkCollection(field, ctrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:start', field.schema.displayName, 1);
        notification_service_1.NotificationService.info({ key: index_1.T.COLLECTION_LINK_START });
        const collection = yield ctrl.chooseLinkingCollection(field);
        if (collection == null) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:cancel', field.schema.displayName, 1);
            return;
        }
        if (collection.uuid === ctrl.collection.uuid) {
            notification_service_1.NotificationService.warn({ key: index_1.T.COLLECTION_LINK_INVALID });
            return;
        }
        field.Mutator.collection(collection.collectionId);
        if (ctrl.kind === 'TopologicalEditorCollectionEditCtrl') {
            point_collection_cache_1.TopologicalPointCollectionCache.addVector(ctrl.collectionEditState.collectionRevision, field);
            ctrl.redrawMap();
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:success', field.schema.displayName, 1);
    });
}
function viewVectorManualEdit(field, ctrl) {
    let inputState = ctrl.changeState.getState(field.id);
    if (!inputState) {
        const { value } = field;
        inputState = new vector_input_state_1.VectorInputState(field.schema.displayName);
        inputState.onValue(() => {
            field.Mutator.manual(inputState.value);
            // This will ensure topo map is updated (if it exists) and a user is updating vector locations
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(field.collection.revision);
        });
        ctrl.changeState.addState(field.id, inputState);
        if (value != null) {
            inputState.setValue({
                distance: value.distance,
                bearing: value.bearing,
                pitch: value.pitch
            });
        }
    }
    // If none of the inputs are focused, and the field model value changes
    // the input state should also update.
    if (field.value !== null && !(inputState.distance.meters.focused ||
        inputState.distance.inch.focused ||
        inputState.distance.feet.focused ||
        inputState.bearing.focused)) {
        inputState.setValue(field.value);
    }
    const onmouseover = () => {
        page_state_1.CurrentState.setHoverId(field.id);
    };
    const onmouseout = () => {
        page_state_1.CurrentState.setHoverId(null);
    };
    const className = input_1.Input.CSS.container;
    return (0, mithril_1.m)('div', { className, onmouseover, onmouseout, onclick }, [
        vector_input_1.VectorInput.view(inputState)
    ]);
}
function viewManualEditButton(field) {
    return field_action_button_1.FieldActionButton.view({
        icon: icons_1.MaterialIcon.EDIT,
        text: index_1.T.FIELD_VECTOR_PROVIDER_MANUAL,
        onclick: () => field.Mutator.manual({ bearing: 0, distance: 0, pitch: 0 })
    });
}
function viewCollectionLinkButton(field, ctrl) {
    return field_action_button_1.FieldActionButton.view({
        icon: icons_1.MaterialIcon.SPAN_LINK,
        text: index_1.T.COLLECTION_LINK,
        linkingText: index_1.T.COLLECTION_LINK_CANCEL,
        linking: page_state_1.CurrentState.CollectionLink.isLinking,
        onclick: () => {
            if (page_state_1.CurrentState.CollectionLink.isLinking) {
                page_state_1.CurrentState.CollectionLink.cancelLinking();
                return;
            }
            linkCollection(field, ctrl);
        }
    });
}
exports.VectorManualFieldView = {
    viewInline(field) {
        if (!field.hasValue()) {
            return null;
        }
        const onmouseover = () => {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        const onmouseout = () => {
            page_state_1.CurrentState.setHoverId(null);
        };
        const className = input_1.Input.CSS.container;
        return (0, mithril_1.m)('div', { className, onmouseover, onmouseout, onclick }, [
            field_info_1.FieldInfo.viewVectorInline(field.value)
        ]);
    },
    hasDetail(field) {
        return false;
    },
    viewDetail(field) {
        return null;
    },
    viewEdit(field, ctrl) {
        if (field.hasValue()) {
            return viewVectorManualEdit(field, ctrl);
        }
        if (!(services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_LINK)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE))) {
            return viewVectorManualEdit(field, ctrl);
        }
        const children = [];
        if (page_state_1.CurrentState.CollectionLink.isLinking) {
            if (page_state_1.CurrentState.CollectionLink.fieldId === field.id) {
                children.push(viewCollectionLinkButton(field, ctrl));
            }
        }
        else {
            children.push(viewManualEditButton(field));
            children.push(viewCollectionLinkButton(field, ctrl));
        }
        const onmouseover = () => {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        const onmouseout = () => {
            page_state_1.CurrentState.setHoverId(null);
        };
        return (0, mithril_1.m)('div', { className: `${CSS.container} ${CSS.isLinked}`, onmouseover, onmouseout }, children);
    }
};
//# sourceMappingURL=vector.manual.field.view.js.map